module.exports = __webpack_public_path__ + "static/img/5.e8eb475.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/sp/5.png
// module id = x2n9
// module chunks = 0